/** The kebab-case name grammar for daemon-managed plugins addressed as a single path segment
 *  (`src/plugins/marketplace.ts`). Two to 64 chars,
 *  lowercase letters, digits and dashes, first character not a dash.
 *
 *  Plugin ownership, licensing and update boundaries share it with the on-disk loader, rejecting
 *  separators, `..`, absolute paths and empty names before they become directory names.
 *
 *  Agent definitions use the distinct grammar owned by the Subagent plugin: one to 64 characters,
 *  with no trailing or repeated dash. Themes also allow one character and own their grammar. */
export const NAME_RE = /^[a-z0-9][a-z0-9-]{1,63}$/;

/** Return `base` when it's free, otherwise the first `base-2`, `base-3`, … not already in `taken`.
 *  The caller owns normalization and the namespace; this only probes the set and never reserves the result. */
export function uniqueSlug(base: string, taken: ReadonlySet<string>): string {
  if (!taken.has(base)) return base;
  for (let n = 2; ; n++) {
    const candidate = `${base}-${n}`;
    if (!taken.has(candidate)) return candidate;
  }
}
